const NAME = 'SENTRY';
const CNameMapping = {
  [NAME]: NAME,
  sentry: NAME,
  Sentry: NAME,
};

export { NAME, CNameMapping };
